module.exports = __webpack_public_path__ + "img/4.95747e69.png";